<rb-loading-spinner *ngIf="dataLoading" class="spinner"></rb-loading-spinner>
<div class="row ms-0 me-0" *ngIf="errorMessage && !dataLoading">
    <rb-callout type="warning">
        No data for "End State of Charge" chart.
    </rb-callout>
</div>
<div id="soc-end-chart"></div>
<div class="p-2" *ngIf="!dataLoading && !errorMessage">
    <div class="shaded-container ">
        Distribution of final state of charge per charging session.
    </div>
</div>